import { useMutation } from 'react-query';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import {
  getImportAudatexweb,
  getImportCilia,
  getImportI360,
  getImportLocaliza,
  getImportSoma,
  workorderImportCreate,
  workorderImportFromJson,
  workorderImportUpdateCilia,
  workorderImportUpdateCiliaList,
  workorderValidateImportReplace,
} from './WorkOrderImports.service';
import { workorderImportDicionary } from './dicionary';
import { ErrorFieldErrors } from '@/core/request/ErrorResponse';
import { AxiosError } from 'axios';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { WORKORDER_ITEMS_QUERY_KEY } from '../WorkOrdersItems/WorkOrdersItems.hooks';

export function useWorkorderImportCilia() {
  return useMutation(getImportCilia, {
    onSuccess() {
      notification.success({
        message: 'Importação Cilia executada com sucesso',
      });
    },
    onError(error) {
      notificationError(error, {
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkorderImportSoma() {
  return useMutation(getImportSoma, {
    onSuccess() {
      notification.success({
        message: 'Importação Soma executada com sucesso',
      });
    },
    onError(error) {
      notificationError(error, {
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkorderImportI360() {
  return useMutation(getImportI360, {
    onSuccess() {
      notification.success({
        message: 'Importação I360 executada com sucesso',
      });
    },
    onError(error) {
      notificationError(error, {
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkorderImportAudatexweb() {
  return useMutation(getImportAudatexweb, {
    onSuccess() {
      notification.success({
        message: 'Importação Audatexweb executada com sucesso',
      });
    },
    onError(error) {
      notificationError(error, {
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkorderImportLocaliza() {
  return useMutation(getImportLocaliza, {
    onSuccess() {
      notification.success({
        message: 'Importação Localiza executada com sucesso',
      });
    },
    onError(error) {
      notificationError(error, {
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkorderImportCreate() {
  const queryChanel = useQueryChanel();
  return useMutation(workorderImportCreate, {
    onSuccess(_, vars) {
      notification.success({
        message: 'Importação do orçamento executado com sucesso',
      });

      queryChanel({
        removeQueries: [
          [
            'customer/filter',
            {
              licensePlate: vars?.vehicle?.licensePlate,
              active: true,
              rows: 1,
            },
          ],
        ],
      });
    },
    onError(error) {
      const { response } = error as AxiosError<ErrorFieldErrors>;
      const Discount = response?.data.fieldErrors.Discount;

      notificationError(error, {
        translate(errors) {
          if (!!Discount?.length) return Discount;

          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkorderValidateImportReplace() {
  return useMutation(workorderValidateImportReplace, {
    onError(error) {
      const { response } = error as AxiosError<ErrorFieldErrors>;

      if (
        response?.status === 400 &&
        (response?.data.fieldErrors.financial ||
          response.data.fieldErrors.purchase)
      )
        return;

      notificationError(error, {
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkorderImportFromJson() {
  return useMutation(workorderImportFromJson, {
    onSuccess() {
      notification.success({
        message: 'Importação do orçamento via JSON executado com sucesso',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useWorkOrderImportUpdateCiliaList() {
  return useMutation(workorderImportUpdateCiliaList, {
    onSuccess() {
      notification.success({
        message: 'Atualizações do Cilia carregadas com sucesso.',
        description:
          'Itens atualizados e novos foram encontrados e estão prontos para revisão.',
      });
    },
    onError(error) {
      notificationError(error, {
        message: 'Erro de sincronização',
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}

export function useWorkOrderImportUpdateCilia() {
  const queryChanel = useQueryChanel();

  return useMutation(workorderImportUpdateCilia, {
    onSuccess() {
      notification.success({
        message: 'Atualização concluída',
        description: 'Os itens do Cilia foram atualizados com sucesso.',
      });

      queryChanel({ resetQueries: [WORKORDER_ITEMS_QUERY_KEY] });
    },
    onError(error) {
      notificationError(error, {
        translate(errors) {
          return errors.map((err) => workorderImportDicionary[err] || err);
        },
      });
    },
  });
}
